<div class="row" style="margin-top:65px">
  <div class="col-12">
    <ul class="nav nav-tabs" id="pfsTabs" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link active" id="dashboard-tab" data-bs-toggle="tab" data-bs-target="#dashboard"
          type="button" role="tab" aria-controls="dashboard" aria-selected="false">
          <i class="fas fa-file-alt"></i> Dashboard
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="summary-tab" data-bs-toggle="tab" data-bs-target="#summary" type="button"
          role="tab" aria-controls="summary" aria-selected="false">
          <i class="fas fa-file-alt"></i> Summary
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="client-charts-tab" data-bs-toggle="tab" data-bs-target="#client-charts"
          type="button" role="tab" aria-controls="client-charts" aria-selected="false">
          <i class="fas fa-sliders-h"></i> Client Charts
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" routerLink="/dynamicsqlgrid/wos_pfs_chartinfo" routerLinkActive="active">
          <i class="fas fa-file-alt"></i> Chart Info
        </a>
      </li>

      <li class="nav-item" role="presentation">
        <button class="nav-link" id="grid-tab" data-bs-toggle="tab" data-bs-target="#grid" type="button" role="tab"
          aria-controls="grid" aria-selected="false">
          <i class="fas fa-table"></i> Holdings List
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="charts-tab" data-bs-toggle="tab" data-bs-target="#charts" type="button" role="tab"
          aria-controls="charts" aria-selected="false">
          <i class="fas fa-chart-bar"></i> Charts
        </button>
      </li>
    </ul>

    <div class="tab-content mt-3" id="pfsTabsContent">
      <div class="tab-pane fade show active" id="dashboard" role="tabpanel" aria-labelledby="dashboard-tab">
        <app-pfs-dashboard></app-pfs-dashboard>
      </div>
      <div class="tab-pane fade" id="summary" role="tabpanel" aria-labelledby="summary-tab">
        <app-pfs-summary></app-pfs-summary>
      </div>
      <div class="tab-pane fade" id="client-charts" role="tabpanel" aria-labelledby="client-charts-tab">
        <app-pfs-client-charts></app-pfs-client-charts>
      </div>
      <div class="tab-pane fade" id="grid" role="tabpanel" aria-labelledby="grid-tab">
        <app-pfs-holdings-list></app-pfs-holdings-list>
      </div>
      <div class="tab-pane fade" id="charts" role="tabpanel" aria-labelledby="charts-tab">
        <app-pfs-charts></app-pfs-charts>
      </div>
    </div>
  </div>
</div>
